import React from "react";
import { useField, useFormikContext } from "formik";
import { DatePicker } from "antd";
import dayjs from 'dayjs';
const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function DatePickerField({ label, showTime, ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();
  const [field] = useField(props);
  return (
    <>
      <div>{label && <label>{label}</label>}</div>
      <DatePicker
        needConfirm={false}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        style={{ width: "100%" }}
        onChange={(val) => {
          setFieldValue(
            field.name,
            val ? (showTime ? val.format("YYYY-MM-DD HH:mm") : val.format("YYYY-MM-DD")) : ""
          );
        }}
        format={showTime ? 'YYYY-MM-DD hh:mm a' : 'YYYY-MM-DD'}
        showTime={showTime && { format: "hh:mm a" }}
        value={field.value ? (showTime ? dayjs(field.value, "YYYY-MM-DD HH:mm") : dayjs(field.value, "YYYY-MM-DD")) : ""}
        {...props}
      />
      {errors[field.name] && touched[field.name] ? (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      ) : (
        // <div className="feedback">
        //   Please enter <b>{props.label}</b> in {props.showTime ? 'yyyy-mm-dd hh:mm' : 'yyyy-mm-dd'} format
        // </div>
        <div className="feedback">
          Use {props.showTime ? 'yyyy-mm-dd hh:mm' : 'yyyy-mm-dd'} format
        </div>
      )}
    </>
  );
}
